import { ISelectItem } from "@/types";
import { IAttachment } from "@/types/attachment";
import {
  IMember,
  IMemberCreateRequest,
  IMemberListRequest,
  IMemberRequest,
  IMemberUpdateRequest,
} from "@/types/member";
import { IProfile } from "@/types/profile";
import { IProgress } from "@/types/progress";
import { IQualification, IQualificationRequest } from "@/types/qualification";
import { ISkill } from "@/types/skill";
import { ITicket } from "@/types/ticket";
import moment from "moment";
import { Attachment } from "./attachment";
import { ListRequest } from "./listRequest";
import { Profile } from "./profile";
import { Progress } from "./progress";
import { Qualification, QualificationRequest } from "./qualification";
import { Skill } from "./skill";
import { User } from "./user";

export class Member extends User {
  public profile: IProfile = new Profile();
  public skills?: ISkill[] = [];
  public qualifications?: IQualification[] = [];
  public tickets?: ITicket[] = [];
  public progress?: IProgress[] = [];
  public attachment: IAttachment = new Attachment();

  constructor(props?: IMember) {
    super(props);

    if (!props) {
      return;
    }

    Object.assign(this, props);

    this.profile = new Profile(props.profile);
    this.skills = props.skills?.map((item) => new Skill(item));
    this.qualifications = props.qualifications?.map(
      (item) => new Qualification(item)
    );
    this.attachment = new Attachment(props.image);
    if (props.progress) {
      this.progress = props.progress.map((item) => new Progress(item));
    }
    if (props.progress) {
      this.progress = props.progress.map((item) => new Progress(item));
    }
  }

  public static toSelectItem(member: IMember): ISelectItem {
    return {
      text: member.name,
      value: member.id,
    };
  }
}

export class MemberRequest implements IMemberRequest {
  public name = "";
  public kana = "";
  public nickname = "";
  public birthday = "";
  public gender = 0;
  public railroad = "";
  public station = "";
  public email = "";
  public password = "";
  public employment_id = 0;
  public department_id = 0;
  public charge_id = undefined;
  public reward_lower = undefined;
  public reward_upper = undefined;
  public summary = "";
  public memo = "";
  public skills?: number[] = [];
  public qualifications?: IQualificationRequest[] = [];
  public progress?: string[] = [];
  public upload_file = "";

  [key: string]: unknown;

  public constructor() {
    this.qualifications = [
      new Qualification(),
      new Qualification(),
      new Qualification(),
    ];
  }
}

export class MemberCreateRequest
  extends MemberRequest
  implements IMemberCreateRequest {}

export class MemberUpdateRequest
  extends MemberRequest
  implements IMemberUpdateRequest
{
  public id = 0;

  public constructor(props?: IMember) {
    super();

    if (!props) {
      return;
    }

    Object.assign(this, props, new Profile(props.profile));
    this.id = props.id;
    this.birthday = this.birthday
      ? moment(props.profile.birthday).format("YYYY-MM-DD")
      : "";

    this.skills = props.skills?.map((item) => item.id);
    this.qualifications = props.qualifications?.map((item) => {
      item.acquisition_at
        ? (item.acquisition_at = moment(item.acquisition_at)
            .format("YYYY-MM-DD")
            .toString())
        : "";
      return new QualificationRequest(item);
    });

    if (props.progress) {
      this.progress = props.progress.map((item) => item.name);
    }
  }
}

export class MemberListRequest
  extends ListRequest
  implements IMemberListRequest
{
  // public status = 0;
  public skills = [];
  public gender = 0;
  public operating = false;
  public recruiting = false;
  public removed = false;
}
